// @flow
import * as React from 'react';
import * as localStorage from 'utils/localStorage';
import styled from 'styled-components';
import PrintHidden from 'components/PrintHidden';
import Box from 'components/Box';
import Icon from 'components/Icon';
import Button, { TrackedPrimaryButtonLink } from 'components/Button';
import { H5, BodySmall } from 'components/Text';
import { gutterWidth, colors } from '../theme';

const { useState, useEffect } = React;

export const BANNER_NAME = 'gradFairsBannerDismissed2020';

export const bannerIsDismissed = () => {
  const isDismissed = localStorage.getItem(BANNER_NAME);
  return isDismissed === 'true' || isDismissed === true;
};

const CtaButton = styled(TrackedPrimaryButtonLink)`
  padding-left: 24px;
  padding-right: 24px;
`;

const GradFairsBanner = () => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(bannerIsDismissed());
  }, []);

  const close = () => {
    localStorage.setItem(BANNER_NAME, 'true');
    setDismissed(true);
  };

  return dismissed ? null : (
    <PrintHidden>
      <Box
        position="relative"
        zIndex="1"
        px={gutterWidth / 2}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="center"
        bg={colors.waterBlue}
        color="white"
      >
        <Box
          py={10}
          mx={16}
          display="flex"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
        >
          <H5 my={0}>Announcing 2020 Virtual Grad Fair dates!</H5>

          <BodySmall display={['none', null, null, 'block']}>
            <Box component="strong" mx={12}>
              -
            </Box>
            Connect with grad programs that can help drive change.
          </BodySmall>
        </Box>

        <Box mx={16} py={10}>
          <CtaButton
            size="small"
            reverse
            href="/grad-schools/attend"
            eventName="Grad Fairs Banner CTA"
            onClick={close}
          >
            Learn More
          </CtaButton>
        </Box>

        <Box
          position="absolute"
          right={gutterWidth / 2}
          top="50%"
          transform="translateY(-50%)"
        >
          <Button
            data-qa-id="flash-message-close"
            onClick={close}
            aria-label={getText('Close alert message')}
          >
            <Icon name="close" width={13} height={12} fill="currentColor" />
          </Button>
        </Box>
      </Box>
    </PrintHidden>
  );
};

export default GradFairsBanner;
